import React from 'react';
import styled from 'styled-components';
import { trackFeatureAction, trackExternalNavigation } from '../../../analytics/googleAnalytics';

const MigrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 125vh;
  padding: 2rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const MessageCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 500px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  color: white;
  font-size: 2rem;
`;

const Title = styled.h1`
  color: #2d3748;
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
  line-height: 1.3;
`;

const Message = styled.p`
  color: #4a5568;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const Highlight = styled.span`
  color: #667eea;
  font-weight: 600;
`;

const ActionButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Footnote = styled.p`
  color: #718096;
  font-size: 0.9rem;
  margin-top: 2rem;
  font-style: italic;
`;

function Collexa() {
  const handleRedirect = () => {
    trackFeatureAction(
      "Collexa",
      "Collexa Application",
      "redirect"
    );

    trackExternalNavigation(
      "Collexa",
      "Collexa Application",
      "Collexa Reports"
    );

    window.open(
      "https://www.collexa.zielfintech.com/reports",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <MigrationContainer>
      <MessageCard>
        <IconWrapper>
          📊
        </IconWrapper>
        
        <Title>
          Reports Have Been Migrated
        </Title>
        
        <Message>
          All collection reports have been successfully migrated to 
          <Highlight> Collexa </Highlight> 
          for better management.
        </Message>
        
        <Message>
          Please refer to Collexa for all your collection reporting needs.
        </Message>
        
        <ActionButton onClick={handleRedirect}>
          Go to Collexa
        </ActionButton>
        
       
      </MessageCard>
    </MigrationContainer>
  );
}

export default Collexa;